module.exports = __webpack_public_path__ + "media/images/call-white-d1addb74058aa83c6282461c7d8df970.svg";